import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=52db450c&scoped=true"
import script from "./CategoryProducts.vue?vue&type=script&lang=js"
export * from "./CategoryProducts.vue?vue&type=script&lang=js"
import style0 from "./CategoryProducts.vue?vue&type=style&index=0&id=52db450c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db450c",
  null
  
)

export default component.exports